/**
 * @owner @Appboy/messaging-experience
 */
import { tagRemoteLookupValidators } from "../.generated/tagRemoteLookup";
import type { TagRemoteLookupProvider } from "../.generated/tagRemoteLookup";

export const tagProvider: TagRemoteLookupProvider = {
  mapItemToId: (item) => item.id,
  mapIdToString: (id) => id,
  mapItemToSearchString: (item) => item.name,
  validators: tagRemoteLookupValidators,
};
